import React from "react";
import jwt_decode from 'jwt-decode';
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { v4 as uuidv4 } from 'uuid';
import plusimg from "../../images/common/plus.png"
import exportimg from "../../images/common/xlsx.png"
import deletepng from "../../images/common/deleteBlue.png"
import editimg from "../../images/common/pencil.png"
import onimg from "../../images/admin/on-button.png"
import offimg from "../../images/admin/off-button.png"
import history from "../history";
import {Form,Row,Modal,Button as ButtonBootstrap} from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from 'react-toastify';    
import 'react-toastify/dist/ReactToastify.css'; 
import PhoneCode from '../ui/Phonecode';
import {config} from '../../constants';
import '../../css/Buttons.css';
import UserRightsComponent from "./pages/customComponents/UserRightsComponent";
import CircleSign from "../ui/CircleSign";
import { exportToExcel } from '../../utils/exportMethods'; 
import ConfirmationModal from "../ui/ConfirmationModal";
import ConfirmDialog from './pages/customComponents/ConfirmDialog';
import Maximize from "../ui/Maximize";
import Minimize from "../ui/Minimize";
import CustomDataGrid from "./pages/customComponents/CustomDataGrid";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';

const url = config.url.URL; //"http://localhost:52344";

const dataSource = createStore({
  key: "userId",
  loadUrl: `${url}/UserMicroservice`,
  insertUrl: `${url}/InsertOrder`,
  updateUrl: `${url}/UpdateOrder`,
  deleteUrl: `${url}/UserMicroservice`, ///DeleteOrder
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = "";
const LoadSubmenu = (section) =>{
  history.push(appName+"/admin" + (section != "" ? "/"+section : "")) ;
}

const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const enableMsg = "Are you sure you want to enable this User? If so, the User will receive an email with new credentials.";
const disableMsg = "Are you sure you want to disable this User? If so, the User won't be able to login anymore.";
    
const exportUserToExcel = async (apiData) => {
  const headers = [
    { header: 'Login', key: 'login', autoFit: true },
    { header: 'First Name', key: 'firstName', autoFit: true },
    { header: 'Last Name', key: 'lastName', autoFit: true },
    { header: 'Email', key: 'email', autoFit: true },
    { header: 'Identity Level', key: 'identityLevel', autoFit: true },
    { header: 'Entity Type', key: 'identityType', autoFit: true },
    { header: 'Profile Name', key: 'profileName', autoFit: true },
    { header: 'Role Name', key: 'roleName', autoFit: true },
    { header: 'Last Connection', key: 'lastConnection', autoFit: true },
  ];

  await exportToExcel(headers, apiData, 'users_extract', 'Users Extract');
};

class UserAdministration extends React.Component {
    constructor(props) {
        super(props);
        this.applyFilterTypes = [{
          key: "auto",
          name: "Immediately"
        }, {
          key: "onClick",
          name: "On Button Click"
        }];
        this.state = {
          showFilterRow: true,
          showHeaderFilter: false,
          currentFilter: this.applyFilterTypes[0].key,
          showColumnLines: false,
          showRowLines: true,
          showBorders: true,
          rowAlternationEnabled: true,
          showModal : false,
          showEditModal: false,
          showConfirmationModal: false,
          selectedRowIndex: "",
          CountUserRights: 1,
          RolesSelected: [],
          showUserMenu: true,
          showProfileMenu: true,
          showRoleMenu: true,
          fullscreen:false,
          Scopes: [],
          Roles: [],
          createValidation: true,
          editValidation: true,
          firstNameValidation: true,
          lastNameValidation: true,
          emailValidation: true,
          emailVal: true,
          entityValidation: true,
          editfirstNameValidation: true,
          editlastNameValidation: true,
          editemailValidation: true,
          editemailVal: true,
          editentityValidation: true,
          validation: true,
          duplicatedEmail: true,
          oldCheckValue: false,
          selectedRowEmail:"",
          disablePass: false,
          disablePassEdit: false,
          isPassChecked:false,
          showPassword: false,
          showEditPassword: false,
          passwordVal:'',
          passError: true,
          settextError: "Required",
          isCreating: false
        };
        this.dataGrid = null;
        this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
        this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
        this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
        this.UserRights1 = React.createRef();
        this.confDiag = React.createRef();
        this.userIsEnabled = React.createRef();
    }

    fullscreenHandler=()=>{
      this.setState(prevState =>({fullscreen: !prevState.fullscreen}));
    }

    selectedChanged(e) {
      this.setState({
        selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0])
      });
    }

    closeConfirmationModal = ()=>{
      this.setState({ showConfirmationModal: false });
    }

    doubleCloseModals = () => {
      const { state } = this.props.location;
      if (typeof state !== "undefined" && state != null) {
        if (state.showNewPopup) {
          history.push({ pathname: "/admin", state: { showNewPopup: false } });
        }
      }
      this.setState({
        showModal: false,
        showEditModal: false,
        showConfirmationModal: false,
      });
    };

    useRefresh = ()=>{
      this.dataGrid.useRefresh();
      this.fetchScopes();
      this.fetchRoles();
      this.setState({
        showModal: false,
        showEditModal: false,
        showConfirmationModal: false,
      });
    }

    togglePasswordVisibility = () => {
      this.setState({showPassword: !this.state.showPassword});
    };
  
    toggleEditPasswordVisibility = () => {
      this.setState({showEditPassword: !this.state.showEditPassword});
    };

    passwordHandler = (e)=> {
      this.setState({passwordVal: e.target.value});
    };

    handleClose = () =>{
      this.setState({showConfirmationModal: true,});
    }

    openModal = () => {   
      this.setState({
        showModal: true,
        duplicatedEmail: true,
        createValidation: true,
        firstNameValidation: true,
        lastNameValidation: true,
        emailValidation: true,
        emailVal: true,
        entityValidation: true,
        validation: true,
        passError: true,
        showPassword: false,
        passwordVal:'',
      });
      this.setState({CountUserRights: 1})
      this.setState({isPassChecked: true})
      this.setState({disablePass: true})
    }

    handleEditClose = () =>{
      this.setState({showConfirmationModal: true,});
    }

  fetchScopes() {
    let initialScopes = [];
    apiClient.get(`${url}/UserMicroservice/Scope`)
      .then(response => {
        const data = response.data;
        initialScopes = data;
        this.setState({
          Scopes: initialScopes,
        });
      });
  }

  fetchRoles() {
    apiClient.get(`${url}/RoleMicroservice`)
      .then(response => {
        const data = response.data;
        let values = data.map(item => {
          return {
            label: item.name,
            value: item.roleId
          }
        });
        this.setState({ Roles: values });
      });
  }
      
    openEditModal = (e) => {         
      this.setState({
        showEditModal: true,
        duplicatedEmail: true,
        editValidation: true,
        editfirstNameValidation: true,
        editlastNameValidation: true,
        editemailValidation: true,
        editemailVal: true,
        validation: true,
        passwordVal:'',
        showPassword: false,
        passError: true
      });
      this.setState({CountUserRights: 1});
      console.log(e.row.data);
      this.setState({selectedRowEmail: e.row.data.email})
      this.setState({selectedRowIndex: e.row.data.userId});

      this.refs.login_edit.value = e.row.data.email;
      this.refs.firstname_edit.value = e.row.data.firstName;
      this.refs.lastname_edit.value = e.row.data.lastName;
      this.refs.email_edit.value = e.row.data.email;
      this.refs.chk_generate_password_edit.checked = false; //JSON.parse(e.row.data.properties).PasswordType;
      this.refs.identitytype_edit.value = JSON.parse(e.row.data.properties).IdentityLevel;
      this.refs.entitytype_edit.value = JSON.parse(e.row.data.properties).IdentityType;
      this.refs.phoneCode_edit.refs.phonecode.value = JSON.parse(e.row.data.properties).PhoneCode;
      this.refs.phonenumber_edit.value = JSON.parse(e.row.data.properties).PhoneNumber;
      this.refs.jobposition_edit.value = JSON.parse(e.row.data.properties).JobPosition;
      this.userIsEnabled.current.checked = e.row.data.isEnabled;
      this.setState({oldCheckValue: e.row.data.isEnabled});

      apiClient.get(`${url}/UserMicroservice/AllUserProfile/${e.row.data.userId}`)
        .then(response => {
          //Inside the loop, the index variable is defined as i + 1 to match the dynamic variable names and IDs of the user profile elements.
          const data = response.data;
          for (let i = 0; i < data.length; i++) {
            const index = i + 1;
            const userRightsRef = this.refs[`UserRights${index}`];
      
            if (index >= 2) {
              document.getElementById(`UserRights${index}`).style.display = "flex";
              this.state.CountUserRights += 1;
            }
      
            userRightsRef.refs.UserRightsName.value = data[i].name;
            userRightsRef.state.scopeId = data[i].scopeId;
            userRightsRef.setProfile();
            userRightsRef.state.idsSelected = data[i].profileUserRoles.map(obj => obj.roleId);
            userRightsRef.setRoles();
            userRightsRef.state.profileId =  data[i].profileId;
           //The dynamic variable names and IDs are used to access the correct elements and update their values based on the retrieved data.
          }
        });

        this.passwordEditDisableHandler();
    }

  onExportToExcel = () => {
    apiClient.get(`${url}/UserMicroservice/Export`)
      .then(response => {
        if (response) {
          const data = response.data;
          exportUserToExcel(data, 'users');
          toast.success('Users Excel export file has been generated');
        }
      });
  }

   

    onCreateUser =()=>{
      if (this.state.isCreating) return;
      this.setState({ isCreating: true });
      const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
        const emailVal = emailRegex.test(this.refs.email.value)
        this.setState({ duplicatedEmail: true })
   
        //These arrays will hold the validation values for each iteration
        let rightsCont = [];
        let profileCont = [];
        let roleCont = [];
        let roleVall = false;
        
        //The code then enters a loop that iterates from 1 to 10. This loop is used to extract the validation values from different references
        for (let i = 1; i <= 10; i++) {
          let { rightValidation, profileValidation, roleValidation } = this.refs[`UserRights${i}`].getValidation();
          
          rightsCont.push(rightValidation);
          profileCont.push(profileValidation);
          roleCont.push(roleValidation);
        }
        
        //After extracting all the validation values, another loop is used to iterate through the arrays and evaluate the conditions.
        for (let i = 0; i < 10; i++) {
          if (!rightsCont[i] && !profileCont[i] && !roleCont[i]) continue;
          
          if (rightsCont[i] && profileCont[i] && roleCont[i]) {
            roleVall = true;
          } else {
            roleVall = false;
            break;
          }
        }
        
      if (this.refs.firstname.value == ""){
        this.setState({ firstNameValidation: false})
      } else {this.setState({ firstNameValidation: true})}

      if (this.refs.lastname.value == ""){
        this.setState({ lastNameValidation: false})
      } else {this.setState({ lastNameValidation: true})}

      if (this.refs.email.value == ""){
        this.setState({ emailValidation: false})
      } else {this.setState({ emailValidation: true})}

      if (!emailVal){
        this.setState({ emailVal: false})
      } else {this.setState({ emailVal: true})}

      if (this.refs.password.value == '' && !this.state.disablePass){
        this.setState({ passError: false, settextError: "Required"})
      } else {this.setState({ passError: true})}

      if (this.refs.entitytype.value == ""){
        this.setState({ entityValidation: false})
      } else {this.setState({ entityValidation: true})}

      if(!this.refs.firstname.value == "" && !this.refs.lastname.value == "" && !this.refs.email.value == "" && emailVal && !this.refs.entitytype.value == "" && !(this.refs.password.value == '' && !this.state.disablePass) && roleVall){
        this.setState({createValidation: true})

        let userInfo ={
          FirstName:this.refs.firstname.value.trim(),
          LastName:this.refs.lastname.value.trim(),
          Email:this.refs.email.value.trim(),
          Identifier:this.refs.email.value.trim(),
          Properties:`{"PhoneCode":"${this.refs.phoneCode.refs.phonecode.value}","PhoneNumber":"${this.refs.phonenumber.value}","IdentityLevel":"${this.refs.identitytype.value}","IdentityType":"${this.refs.entitytype.value}","JobPosition":"${this.refs.jobposition.value}","PasswordType":${this.refs.chk_generate_password.checked}}`,
          IsEnabled:true,
          PasswordExpirationDate: new Date(),
          Password: this.refs.chk_generate_password.checked ? "" : this.refs.password.value.trim(),
          Hash:null,
          Salt:null,
          UserRightsJson: this.getUserRightsJson()
        };

        apiClient.post(`${url}/UserMicroservice`, userInfo)
          .then(response => {
            if (response) {
              const data = response.data;
              if (data.statusCode == 400) {
                this.setState({ duplicatedEmail: false })
                return;
              } else if (data.statusCode == 500) {
                toast.error(data.headers[0].value[0]);
              } else if (data.statusCode == 406) {
                //show this under password textbox
                this.setState({ passError: false, settextError: data.headers[0].value[0] })
                return;
              } else {
                toast.success('User has been created');
                this.doubleCloseModals();
                const { state } = this.props.location;
                if (typeof (state) !== 'undefined' && state != null) {
                  if (state.showNewPopup) {
                    history.push({ pathname: "/admin", state: { 'showNewPopup': false } });
                  }
                } else {
                  this.useRefresh();
                }
              }
            }
          }).catch((error) => console.log(error))
          .finally(() => {
            this.setState({ isCreating: false });
          });          
      } else {
        this.setState({ createValidation: false, isCreating: false })
        return;
      }
    }

      onEditUser =()=>{
      if (this.state.isCreating) return;
      this.setState({ isCreating: true });        
      let duplicated
      const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
          const emailVal = emailRegex.test(this.refs.email_edit.value)
          this.setState({ duplicatedEmail: true })
      let selectedRowEmail = this.state.selectedRowEmail;

      //These arrays will hold the validation values for each iteration
      let rightsCont = [];
      let profileCont = [];
      let roleCont = [];

      let roleVall = false;

      //The code then enters a loop that iterates from 1 to 10. This loop is used to extract the validation values from different references
      for (let i = 1; i <= 10; i++) {
        let { rightValidation, profileValidation, roleValidation } = this.refs[`UserRights${i}`].getValidation();
        
        rightsCont.push(rightValidation);
        profileCont.push(profileValidation);
        roleCont.push(roleValidation);
      }

      //After extracting all the validation values, another loop is used to iterate through the arrays and evaluate the conditions.
      for (let i = 0; i < 10; i++) {
        if (!rightsCont[i] && !profileCont[i] && !roleCont[i]) continue;
        
        if (rightsCont[i] && profileCont[i] && roleCont[i]) {
          roleVall = true;
        } else {
          roleVall = false;
          break;
        }
      }

        if (this.refs.firstname_edit.value == "") {
          this.setState({ editfirstNameValidation: false })
        } else { this.setState({ editfirstNameValidation: true }) }

        if (this.refs.lastname_edit.value == "") {
          this.setState({ editlastNameValidation: false })
        } else { this.setState({ editlastNameValidation: true }) }

        if (this.refs.email_edit.value == "") {
          this.setState({ editemailValidation: false })
        } else { this.setState({ editemailValidation: true }) }

        if (!emailVal) {
          this.setState({ editemailVal: false })
        } else { this.setState({ editemailVal: true }) }

        if (this.refs.entitytype_edit.value == "") {
          this.setState({ editentityValidation: false })
        } else { this.setState({ editentityValidation: true }) }


        if (!this.refs.firstname_edit.value == "" && !this.refs.lastname_edit.value == "" && !this.refs.email_edit.value == "" && emailVal && !this.refs.entitytype_edit.value == "" && roleVall) {

          this.refs.email_edit.value == selectedRowEmail ? duplicated = false : duplicated = true;

          this.setState({ editValidation: true })

          let userInfo = {
            UserId: this.state.selectedRowIndex,
            FirstName: this.refs.firstname_edit.value.trim(),
            LastName: this.refs.lastname_edit.value.trim(),
            Email: this.refs.email_edit.value.trim(),
            Identifier: this.refs.email_edit.value,
            Properties: `{"PhoneCode":"${this.refs.phoneCode_edit.refs.phonecode.value}","PhoneNumber":"${this.refs.phonenumber_edit.value}","IdentityLevel":"${this.refs.identitytype_edit.value}","IdentityType":"${this.refs.entitytype_edit.value}","JobPosition":"${this.refs.jobposition_edit.value}","PasswordType":${this.refs.chk_generate_password_edit.checked}}`,
            PasswordExpirationDate: new Date(),
            Password: this.refs.chk_generate_password_edit.checked ? "" : this.refs.password_edit.value.trim(),
            Hash: null,
            Salt: null,
            UserRightsJson: this.getUserRightsJson(),
            ownEmail: duplicated,
            isAutoGenPassChecked: this.refs.chk_generate_password_edit.checked
          };


          apiClient.put(`${url}/UserMicroservice`, userInfo)
            .then(response => {
              const data = response.data;
              if (data) {
                if (data.statusCode == 400) {
                  this.setState({ duplicatedEmail: false })
                  return;
                } else if (data.statusCode == 406) {
                  //show this under password textbox
                  this.setState({ passError: false, settextError: data.headers[0].value[0] })
                  return;
                } else if (data.statusCode == 304) {
                  toast.error("User Not Found! Can't modify user please contact support.");
                } else if (data.statusCode == 500) {
                  toast.error(data.headers[0].value[0]);
                } else {
                  if (this.state.oldCheckValue != this.userIsEnabled.current.checked) {
                    this.confDiag.current.state.status = this.userIsEnabled.current.checked
                    this.confDiag.current.state.inEditMode = true;
                    this.confDiag.current.state.key = this.state.selectedRowIndex;
                    this.confDiag.current.handleChangeConfirmMessageAndOpenDialog(
                      this.userIsEnabled.current.checked ? enableMsg : disableMsg
                    );
                  } else {
                    this.showEditSuccessToast();
                    this.doubleCloseModals();
                    this.useRefresh();
                  }
                }
              }
            }).catch((error) => console.log(error))
            .finally(() => {
              this.setState({ isCreating: false });
            });            
        } else {
          this.setState({ editValidation: false, isCreating: false  })
          return;
        }
    }

      showEditSuccessToast = () => {
        toast.success('User has been updated');
      }
      showDisabledEnabledToast = (value) => {
        if(!this.confDiag.current.state.inEditMode) {
          if(!value) {
            toast.success('User has been enabled');
          }
          else {
            toast.success('User has been disabled');
          }
        }
        else {
          if(value) {
            toast.success('User has been enabled');
          }
          else {
            toast.success('User has been disabled');
          }
        }
      }

      //iterates through the UserRights elements, extracts their values, and constructs a JSON string
      getUserRightsJson = () => {
        let json = `{"UserRights":[`;
      
        for (let i = 1; i <= this.state.CountUserRights; i++) {
          if (document.getElementById(`UserRights${i}`).style.display !== "none") {
            const name = this.refs[`UserRights${i}`].refs.UserRightsName.value;
            const profile = this.refs[`UserRights${i}`].refs.Profile.value;
            const roles = this.refs[`UserRights${i}`].getSelectedValues();
      
            let profileId = this.refs[`UserRights${i}`].state.profileId;
            if (!profileId || profileId === "00000000-0000-0000-0000-000000000000") {
              profileId = uuidv4();
            }
      
            json += `{"Name":"${name}", "profileId":"${profileId}", "Profile":"${profile}", "Roles":[${roles}]},`;
          }
        }
        json = json.slice(0, -1) + `]}`;      
        if (this.refs.UserRights1.refs.UserRightsName.value === "" || this.refs.UserRights1.refs.Profile.value === "" || this.refs.UserRights1.state.optionsSelected.length === 0) {
          return false;
        } else {
          return json;
        }
      }

      onAddBtnClick =()=> {
        if (this.state.CountUserRights < 10){
          this.state.CountUserRights += 1;
          document.getElementById("UserRights" + this.state.CountUserRights).style.display = "flex";
        }
      };

      onDeleteBtnClick =(id)=> {
          document.getElementById(id).style.display = "none";
      };

      passwordDisableHandler =()=>{
        if(this.refs.chk_generate_password.checked){
          this.setState({disablePass: true})
          this.setState({isPassChecked: true})
        }else{
          this.setState({disablePass: false})
          this.setState({isPassChecked: false})
        }
      }

      passwordEditDisableHandler =()=>{
        if(this.refs.chk_generate_password_edit.checked){
          this.setState({disablePassEdit: true})
        }else{
          this.setState({disablePassEdit: false})
        }
      }

      componentDidMount(){
        this.fetchScopes();
        this.fetchRoles();
        const decoded = jwt_decode(localStorage.getItem('token'));
        this.setState({
          showUserMenu: decoded.can_manage_users  === "true",
          showProfileMenu: decoded.can_manage_profiles === "true",
          showRoleMenu: decoded.can_manage_roles === "true",
          can_export_to_excel: decoded.can_export_to_excel === "true"
        });
        const { state } = this.props.location;
        if (typeof(state) !== 'undefined' && state != null) {
        if(state.showNewPopup){
          // this.setState({showModal:true});
          this.openModal();
          
        }
      }
      }
      Checkisenabled = (e) =>{
        return e.row.data.isEnabled ;
    }
    Checkisdisabled = (e) =>{
      return !e.row.data.isEnabled ;
    }
    onDeleteEnable = (e) => {
      this.confDiag.current.state.key = e.row.data.userId;
      this.confDiag.current.state.status = e.row.data.isEnabled;
      this.confDiag.current.state.inEditMode = false;
      this.confDiag.current.handleChangeConfirmMessageAndOpenDialog(enableMsg);
    }
    onDeleteDisable = (e) => {
      this.confDiag.current.state.key = e.row.data.userId;
      this.confDiag.current.state.status = e.row.data.isEnabled;
      this.confDiag.current.state.inEditMode = false;
      this.confDiag.current.handleChangeConfirmMessageAndOpenDialog(disableMsg);
    }
    
  render() {

    const columns = [
      { dataField: "isEnabled", caption: "Status", width: "50%" },
      { dataField: "email", caption: "Login", width: "100%" },
      { dataField: "firstName", caption: "First Name", width: "100%" },
      { dataField: "lastName", caption: "Last Name", width: "100%" },
      { dataField: "email", caption: "Email", width: "100%" },
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      {text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal},
      {text: "btn_enabled", icon: onimg, hint: "Disable", visible: this.Checkisenabled, name: "delete", onClick: this.onDeleteDisable},
      {text: "btn_disabled", icon: offimg, hint: "Enable", visible: this.Checkisdisabled,
        name: "delete", onClick: this.onDeleteEnable},
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
        <div className="div-section-title">
          <span>
            Users Management
          </span>       
        </div>
        <div className="div-section-actions push">
          <button className={this.state.can_export_to_excel ? "btn-section-header" : "btn-section-header hidden" }  onClick={this.onExportToExcel}>
              <img className="img-section-header" src={exportimg}  />
              <label>Export To Excel</label></button>
          <button  className="btn-section-header"  onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New User</label>
          </button>
        </div>
        </div>
        <div className="div-body-section-details-body">
        <div className="div-body-submenu">
          <div className={this.state.showUserMenu ? "div-submenu-link active" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('useradministration')} >              
                <div class="div-submenu-label">
                    <label>Users</label>
                </div> 
                            
            </div>
            <div className={this.state.showProfileMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('profiles')} >              
                <div class="div-submenu-label">
                    <label>Profiles</label>
                </div> 
                            
            </div>
            <div className={this.state.showRoleMenu ? "div-submenu-link" : "div-submenu-link hidden"}  onClick={() => LoadSubmenu('roles')} >              
                <div class="div-submenu-label">
                    <label>Roles</label>
                </div> 
                            
            </div>
          </div>
        <div  className="div-padding-20 div-grid-result">
            <CustomDataGrid
              dataSource={dataSource}
              keyExpr="userId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              onSelectionChanged={this.selectionChanged}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
      </div>
      </div>

      <Modal show={this.state.showModal} onHide={this.handleClose} size="xl" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >New User</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>
       

          <Row className="px-3">
          {!this.state.createValidation && <Row className="mb-3 col-md-12"><p className="mandatory-validation">Mandatory fields are missing. Saving of the User form is not allowed</p></Row>  }
        {!this.state.duplicatedEmail && <Row className="mb-3 col-md-12"><p className="mandatory-validation">This User already exists, your updates cannot be saved.</p></Row>  }
            <div className="div-body-leftside col-md-6">
              <div className="mb-3 col-md-12">
                <label className="lbl_header">User Information</label>
              </div>
              <Form.Group className="mb-3" controlId="Login">
                <Form.Label>Login</Form.Label>
                <Form.Control type="email" ref="login" placeholder="Login" disabled />
              </Form.Group>
    
              <Form.Group className="mb-3" controlId="formBasicCheckbox">
                <Form.Check type="checkbox" ref="chk_generate_password" label="Automatically Generate Password" checked={this.state.isPassChecked} onChange={()=>this.passwordDisableHandler()}/>
              </Form.Group>

              <Row className="mb-3">
                <Form.Group className="mb-3 col-md-6" controlId="Firstname">
                  <Form.Label className={`${this.state.firstNameValidation ? "normal-title" : "validation-title"}`}>First Name  <CircleSign/></Form.Label>
                  <Form.Control className={`${!this.state.firstNameValidation && "validation-control"}`} ref="firstname" placeholder="First Name" />
                  {!this.state.firstNameValidation && <p className="p-required">Required</p>}
                </Form.Group> 

                <Form.Group className="mb-3 col-md-6" controlId="LastName">
                  <Form.Label className={`${this.state.lastNameValidation ? "normal-title" : "validation-title"}`}>Last Name  <CircleSign/></Form.Label>
                  <Form.Control className={`${!this.state.lastNameValidation && "validation-control"}`} ref="lastname" placeholder="Last Name" />
                  {!this.state.lastNameValidation && <p className="p-required">Required</p>}
                </Form.Group>

                <Form.Group className="mb-3 col-md-6" controlId="Password">
                 
                <Form.Label className={`${this.state.passError ? "normal-title" : "validation-title"} margin-bot-1`}>Input Password <CircleSign /></Form.Label>
              <div style={{ display: "flex", position: "relative" }}>

              <Form.Control
                type={this.state.showPassword ? "text" : "password"}
                value={this.state.passwordVal}
                ref="password"
                disabled={this.state.disablePass}
                className={`${!this.state.passError && "validation-control"}`}
                onChange={(e) => this.passwordHandler(e)}
                placeholder="Input Password"
                autoComplete="new-password"
                />
             <div className="eye-pos">
                {this.state.showPassword ? (
                  <EyeSlash fill="blue" onClick={this.togglePasswordVisibility} />
                  ) : (
                    <Eye fill="blue" onClick={this.togglePasswordVisibility} />
                    )}
                    </div>
              </div>
              {!this.state.passError && <p className="p-required" style={{marginBottom:'0'}}>{this.state.settextError}</p>}
                </Form.Group> 

                <Form.Group className="mb-3 col-md-6" controlId="formBasicEmail">
                  <Form.Label className={`${this.state.emailValidation && this.state.emailVal? "normal-title" : "validation-title"}`}>Email  <CircleSign/></Form.Label>
                  <Form.Control
                    className={`${!(this.state.emailValidation && this.state.emailVal) && "validation-control"}`}
                    type="email"
                    ref="email"
                    placeholder="Email"
                    autoComplete="new-password"
                  />
                  {!this.state.emailValidation && <p className="p-required">Required</p>}
                  {!this.state.emailVal && this.state.emailValidation && <p className="p-required">The email adress must include a local part, an @ symbol and a domain name. For example jane.doe@domain.com</p>}
                </Form.Group>
      
                <Form.Group className="mb-3 col-md-6" controlId="IdentityLevel">
                  <Form.Label className="normal-title">Identity Level</Form.Label>
                  <Form.Control  
                    className="select-placeholder"
                    placeholder="Identity Level" 
                    ref="identitytype" 
                    as="select" 
                    type="select"
                    required
                    defaultValue="">
                      <option value="" hidden>Identity Level</option>
                      <option value="Hub">Hub</option>
                      <option value="Local">Local</option>
                  </Form.Control>
                </Form.Group> 

                <Form.Group className="mb-3 col-md-6" controlId="EntityType">
                  <Form.Label className={`${this.state.entityValidation ? "normal-title" : "validation-title"}`}>Entity Type  <CircleSign/></Form.Label>   
                    <Form.Control
                      className={`select-placeholder ${!this.state.entityValidation && "validation-control"}`}
                      placeholder="Entity Type"
                      ref="entitytype"
                      as="select"
                      required
                      defaultValue="">
                    <option value="" hidden>Entity Type</option>
                    <option value="Agency">Agency</option>
                    <option value="Group">Group</option>
                    <option value="Maisons">Maisons</option>
                  </Form.Control>
                  {!this.state.entityValidation && <p className="p-required">Required</p>}
                </Form.Group>
              </Row>
              
              <Row>
                <Form.Group className="mb-3 col-md-3" controlId="PhoneCode">
                  <Form.Label className="normal-title">Phone Code</Form.Label>
                  <PhoneCode ref="phoneCode" />
                </Form.Group> 
                
                <Form.Group className="mb-3 col-md-3" controlId="PhoneNumber">
                  <Form.Label className="normal-title">Phone Number</Form.Label>
                  <Form.Control placeholder="Phone Number" ref="phonenumber" />                        
                </Form.Group> 
    
                <Form.Group className="mb-3 col-md-6" controlId="JobPosition">
                  <Form.Label className="normal-title">Job Position</Form.Label>   
                  <Form.Control placeholder="Job Position" ref="jobposition" />
                </Form.Group>
              </Row>

            </div>
          
            <div className="div-body-leftside col-md-6 padding-left-25">
              <div className="mb-3 col-md-12">
                <label className="lbl_header">User Rights</label>
              </div>

              <div id="UserRights1">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights1" />
              </div>

              <div id="UserRights2" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights2" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights2')} />
              </div>

              <div id="UserRights3" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights3" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights3')} />
              </div>

              <div id="UserRights4" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights4" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights4')} />
              </div>

              <div id="UserRights5" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights5" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights5')} />
              </div>

              <div id="UserRights6" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights6" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights6')} />
              </div>

              <div id="UserRights7" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights7" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights7')} />
              </div>

              <div id="UserRights8" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights8" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights8')} />
              </div>

              <div id="UserRights9" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights9" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights9')} />
              </div>

              <div id="UserRights10" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights10" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights10')} />
              </div>
              
              <div className="profile-to-user-div">
                <p onClick={this.onAddBtnClick} className="profile-to-user-p">Add Profile to User</p>
              </div>

            </div>

          </Row>

      </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap 
          variant="primary" 
          className='btnPrimary' 
          onClick={this.onCreateUser}
          disabled={this.state.isCreating}          
          >
          {this.state.isCreating ? "Creating..." : "Create User"}
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <Modal show={this.state.showEditModal} onHide={this.handleEditClose} size="xl" centered fullscreen={this.state.fullscreen}>
        <Modal.Header closeButton>
          <Modal.Title size="h6" >Edit User</Modal.Title>
          <button
            type="button"
            class="btn btn-primary admin-btn"
            onClick={this.fullscreenHandler}
          >
            {this.state.fullscreen ? <Maximize /> : <Minimize />}
          </button>
        </Modal.Header>
        <Modal.Body>  
        {!this.state.editValidation && <Row><p className="mandatory-validation">Mandatory fields are missing. Saving of the User form is not allowed</p></Row>  }
        {!this.state.duplicatedEmail && <Row className="mb-3 col-md-12"><p className="mandatory-validation">This User already exists, your updates cannot be saved.</p></Row>  }
        
          <Row className="px-3">
         
            <div className="div-body-leftside col-md-6">
              <div className="mb-3 col-md-12">
                <label className="lbl_header">User Information</label>
              </div>
              <Form.Group className="mb-3" controlId="Login">
                <Form.Label>Login</Form.Label>
                <Form.Control type="email" ref="login_edit" placeholder="Login" disabled />
              </Form.Group>
    
              <Form.Group className="mb-3" controlId="formBasicCheckbox">
                <Form.Check type="checkbox" ref="chk_generate_password_edit" label="Automatically Generate Password" onChange={()=>this.passwordEditDisableHandler()}/>
              </Form.Group>

              <Row className="mb-3">
                <Form.Group className="mb-3 col-md-6" controlId="Firstname">
                  <Form.Label className={`${this.state.editfirstNameValidation ? "normal-title" : "validation-title"}`}>First Name  <CircleSign/></Form.Label>
                  <Form.Control ref="firstname_edit" placeholder="First Name"  className={`${!this.state.editfirstNameValidation && "validation-control"}`} />
                  {!this.state.editfirstNameValidation && <p className="p-required">Required</p>}
                </Form.Group> 
                <Form.Group className="mb-3 col-md-6" controlId="LastName">
                  <Form.Label className={`${this.state.editlastNameValidation ? "normal-title" : "validation-title"}`}>Last Name  <CircleSign/></Form.Label>
                  <Form.Control ref="lastname_edit" placeholder="Last Name"  className={`${!this.state.editlastNameValidation && "validation-control"}`} />
                  {!this.state.editlastNameValidation && <p className="p-required">Required</p>}
                </Form.Group>

                <Form.Group className="mb-3 col-md-6" controlId="Password">
                <Form.Label className={`${this.state.passError ? "normal-title" : "validation-title"} margin-bot-1`}>Input Password <CircleSign /></Form.Label>

                  <div style={{ display: "flex", position: "relative" }}>
                  <Form.Control type={this.state.showPassword ? "text" : "password"} value={this.state.passwordVal} ref="password_edit" placeholder="Input Password" disabled={this.state.disablePassEdit} 
                  className={`${!this.state.passError && "validation-control"}`}
                  onChange={(e) => this.passwordHandler(e)}
                  autoComplete="new-password"/>
                  <div className="eye-pos">
                {this.state.showPassword ? (
                  <EyeSlash fill="blue" onClick={this.togglePasswordVisibility} />
                  ) : (
                    <Eye fill="blue" onClick={this.togglePasswordVisibility} />
                    )}
                    </div>
              </div>
              {!this.state.passError && <p className="p-required" style={{marginBottom:'0'}}>{this.state.settextError}</p>}
                </Form.Group> 
                
                <Form.Group className="mb-3 col-md-6" controlId="formBasicEmail">
                  <Form.Label className={`${this.state.editemailValidation && this.state.editemailVal ? "normal-title" : "validation-title"}`}>Email  <CircleSign/></Form.Label>
                  <Form.Control type="email" ref="email_edit" placeholder="Email"  className={`${!(this.state.editemailValidation && this.state.editemailVal) && "validation-control"}`} autoComplete="off"/>
                  {!this.state.editemailValidation && <p className="p-required">Required</p>}
                  {!this.state.editemailVal && this.state.editemailValidation && <p className="p-required">The email adress must include a local part, an @ symbol and a domain name. For example jane.doe@domain.com</p>}

                </Form.Group>
      
                <Form.Group className="mb-3 col-md-6" controlId="IdentityLevel">
                  <Form.Label>Identity Level</Form.Label>
                  <Form.Control  
                    className="select-placeholder"
                    placeholder="Identity Level" 
                    ref="identitytype_edit" 
                    as="select" 
                    required
                    defaultValue=""                    
                    >
                      <option value="" hidden>Identity Level</option>
                      <option value="Hub">Hub</option>
                      <option value="Local">Local</option>
                  </Form.Control>
                </Form.Group> 

                <Form.Group className="mb-3 col-md-6" controlId="EntityType">
                  <Form.Label className={`${this.state.editentityValidation ? "normal-title" : "validation-title"}`}>Entity Type  <CircleSign/></Form.Label>   
                    <Form.Control 
                      placeholder="Entity Type" 
                      ref="entitytype_edit" 
                      as="select" 
                      className={`${!this.state.editentityValidation && "validation-control"}`} >
                      <option value="" hidden>Entity Type</option>
                      <option value="Agency">Agency</option>
                      <option value="Group">Group</option>
                      <option value="Maisons">Maisons</option>
                    </Form.Control>
                  {!this.state.editentityValidation && <p className="p-required">Required</p>}
                </Form.Group>
              </Row>
              
              <Row>
                <Form.Group className="mb-3 col-md-3" controlId="PhoneCode">
                  <Form.Label>Phone Code</Form.Label>   
                  <PhoneCode ref="phoneCode_edit" />
                </Form.Group> 
                
                <Form.Group className="mb-3 col-md-3" controlId="PhoneNumber">
                  <Form.Label>Phone Number</Form.Label>
                  <Form.Control placeholder="Phone Number" ref="phonenumber_edit" />                        
                </Form.Group> 
    
                <Form.Group className="mb-3 col-md-6" controlId="JobPosition">
                  <Form.Label>Job Position</Form.Label>   
                  <Form.Control placeholder="Job Position" ref="jobposition_edit" />
                </Form.Group>
              </Row>

              <br/>
              <Row>
              <Form.Group className="mb-3 col-md-3">
                <Form.Check type="checkbox" label="Is Enabled" ref={this.userIsEnabled}/>
                </Form.Group>
              </Row>

            </div>

            <div className="div-body-leftside col-md-6 padding-left-25">
              <div className="mb-3 col-md-12">
                <label className="lbl_header">User Rights</label>
              </div>

              <div id="UserRights1">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights1" />
              </div>

              <div id="UserRights2" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights2" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights2')} />
              </div>

              <div id="UserRights3" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights3" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights3')} />
              </div>

              <div id="UserRights4" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights4" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights4')} />
              </div>

              <div id="UserRights5" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights5" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights5')} />
              </div>

              <div id="UserRights6" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights6" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights6')} />
              </div>

              <div id="UserRights7" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights7" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights7')} />
              </div>

              <div id="UserRights8" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights8" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights8')} />
              </div>

              <div id="UserRights9" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights9" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights9')} />
              </div>

              <div id="UserRights10" className="display-none">
                <UserRightsComponent isMulti={true} Scopes={this.state.Scopes} values={this.state.Roles} ref="UserRights10" />
                <img src={deletepng} className="delete-img" onClick={() => this.onDeleteBtnClick('UserRights10')} />
              </div>
              
              <div className="profile-to-user-div">
                <p onClick={this.onAddBtnClick} className="profile-to-user-p">Add Profile to User</p>
              </div>

            </div>

          </Row>

      </Modal.Body>
        <Modal.Footer>
        <ButtonBootstrap variant="primary" className='btnPrimary' onClick={this.onEditUser}>
          {this.state.isCreating ? "Updating..." : "Update User"}
          </ButtonBootstrap>
          <ButtonBootstrap variant="secondary" className='btnSecondary' onClick={this.handleEditClose}>
            Cancel
          </ButtonBootstrap>
        </Modal.Footer>
      </Modal> 

      <ConfirmationModal show={this.state.showConfirmationModal} hide={this.closeConfirmationModal} doubleCloseModals={this.doubleCloseModals} msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"/>

      <ConfirmDialog ref={this.confDiag} microserviceName="UserMicroservice" editfunction={this.showDisabledEnabledToast} refreshfunction={this.useRefresh}></ConfirmDialog>
      <ToastContainer position="bottom-right"/>  
      </div>
    );
  }
  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value
    });
    this.clearFilter();
  }
  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value
    });
    this.clearFilter();
  }
  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value
    });
  }
  clearFilter() {
    this.dataGrid.clearFilter();
  }
}

export default UserAdministration;
